import { render, staticRenderFns } from "./textbook.vue?vue&type=template&id=a1eb34c2&scoped=true&"
import script from "./textbook.vue?vue&type=script&lang=js&"
export * from "./textbook.vue?vue&type=script&lang=js&"
import style0 from "./textbook.vue?vue&type=style&index=0&id=a1eb34c2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1eb34c2",
  null
  
)

export default component.exports